
<div class="w-full px-2 max-w-[2000px] mx-auto">
    <div class="sticky-toolbar mb-8 text-[14px]">
        <p-toolbar class="text-[14px] p-0">
            <ng-template #start>
                <p-button label="UPDATE TEAM TARGETS" icon="pi pi-check" severity="secondary" class="mr-2" [style]="{ height: '32px', fontSize: '0.95rem' }" (click)="submitTeam()" *ngIf="!isReadOnly"></p-button>
                <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" class="mr-2" (onClick)="refreshOrders()" />
            </ng-template>
            <ng-template #end>
                <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" class="mr-2" [style]="{ height: '32px', fontSize: '0.95rem' }" (click)="goBack()" />
            </ng-template>
        </p-toolbar>
    </div>
    <!-- <p-toolbar styleClass="mb-2" [style]="{width: '100%', maxWidth: '1200px', margin: '0 auto', minHeight: '60px', height: '60px'}">
    <ng-template #start>
<p-button
    label="Submit Team"
    icon="pi pi-check"
    severity="success"
    class="mr-2"
    [style]="{height: '32px', fontSize: '0.95rem'}"
    (click)="submitTeam()"
/>
    </ng-template>
  <ng-template #end>
  <p-button
    label="Back"
    icon="pi pi-arrow-left"
    severity="secondary"
    class="mr-2"
    [style]="{height: '32px', fontSize: '0.95rem'}"
    (click)="goBack()"
  />

</ng-template>
  </p-toolbar> -->
    <!-- <div class="w-full mb-8 rounded-xl border shadow font-sans">
  <button
    type="button"
    class="flex items-center gap-2 text-xll font-bold text-primary w-full text-left px-6 py-4 border-b focus:outline-none"
    (click)="toggleHeaderPanel()"
    [attr.aria-expanded]="headerPanelOpen"
    aria-controls="headerPanelSection"
  >
    <i class="pi" [ngClass]="headerPanelOpen ? 'pi-minus-circle' : 'pi-plus-circle'"></i>
    Team and Company Details
  </button>
  <div *ngIf="headerPanelOpen" id="headerPanelSection" class="px-6 py-6">
    <div class="flex flex-col md:flex-row w-full h-full gap-1">
  \
      <div class="md:w-[45%] w-full rounded-lg border shadow-sm p-6" style="min-width: 300px">
        <h2 class="text-lg font-bold text-primary mb-4 border-b pb-2 flex items-center gap-2">
          <i class="pi pi-users"></i> Team Details
        </h2>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-sm">
          <div class="flex flex-col">
            <label class="font-medium mb-1">Team Name</label>
            <input type="text" class="p-inputtext p-component w-full" [value]="team.teamName" readonly />
          </div>
          <div class="flex flex-col">
            <label class="font-medium mb-1">Team Lead</label>
            <input type="text" class="p-inputtext p-component w-full" [value]="team.teamLead" readonly />
          </div>
          <div class="flex flex-col">
            <label class="font-medium mb-1">Project</label>
            <input type="text" class="p-inputtext p-component w-full" [value]="team.project" readonly />
          </div>
          <div class="flex flex-col">
            <label class="font-medium mb-1">Number of Members</label>
            <input type="text" class="p-inputtext p-component w-full" [value]="team.members?.length" readonly />
          </div>
        </div>
      </div>

    
      <div class="md:w-[55%] w-full rounded-lg border shadow-sm p-6" style="min-width: 300px">
        <h2 class="text-lg font-bold text-primary mb-4 border-b pb-2 flex items-center gap-2">
          <i class="pi pi-briefcase"></i> Company Details
        </h2>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm">
          <div class="flex flex-col">
            <label class="font-medium mb-1">Company Valuation</label>
            <input type="text" class="p-inputtext p-component w-full" [value]="team.companyValuation | currency" readonly />
          </div>
          <div class="flex flex-col">
            <label class="font-medium mb-1">Team Valuation</label>
            <input type="text" class="p-inputtext p-component w-full" [value]="team.teamValuation | currency" readonly />
          </div>
          <div class="flex flex-col">
            <label class="font-medium mb-1">Quarterly Revenue</label>
            <input type="text" class="p-inputtext p-component w-full" [value]="team.quarterlyRevenue | currency" readonly />
          </div>
          <div class="flex flex-col">
            <label class="font-medium mb-1">Annual Revenue</label>
            <input type="text" class="p-inputtext p-component w-full" [value]="team.annualRevenue | currency" readonly />
          </div>
          <div class="flex flex-col">
            <label class="font-medium mb-1">Region</label>
            <input type="text" class="p-inputtext p-component w-full" [value]="team.region" readonly />
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

    <!-- Task Details Collapsible Section -->
    <div class="w-full mb-4 mt-4" *ngIf="!isReadOnly">
        <div class="w-full flex flex-col gap-1 text-[16px] rounded-xl border p-0 shadow font-sans">
            <button type="button" class="flex items-center gap-2 text-xll font-bold text-primary w-fit text-left px-6 py-4 focus:outline-none" (click)="toggleTaskForm()" [attr.aria-expanded]="showTaskForm" aria-controls="taskFormSection">
                <i class="pi" [ngClass]="showTaskForm ? 'pi-minus-circle' : 'pi-plus-circle'"></i>
                Assign Task to User
            </button>

            <div *ngIf="showTaskForm" id="taskFormSection" class="flex flex-wrap gap-6 mb-6 px-6">
                <form class="flex flex-wrap gap-10" style="flex: 2 1 0%">
                    <!-- User ID -->
                    <div class="flex flex-col ml-4">
                        <label class="mb-1 font-medium" for="userId">User ID</label>
                        <input id="userId" readonly pInputText [(ngModel)]="taskProgress.userId" name="userId" type="number" class="p-inputtext p-component w-[130px]" />
                    </div>

                    <!-- User Name -->
                    <!-- User Name Dropdown -->
                    <div class="flex flex-col ml-4">
                        <label class="mb-1 font-medium" for="userName">User Name</label>
                        <p-autoComplete
                            #userNameAC
                            [(ngModel)]="selectedUser"
                            [suggestions]="filteredUsers"
                            (completeMethod)="filterUsers($event)"
                            [dropdown]="true"
                            [forceSelection]="true"
                            placeholder="Search User"
                            name="userName"
                            id="userName"
                            field="userName"
                            (onSelect)="onUserSelected($event)"
                            class="w-[200px]"
                            (keydown.enter)="targetValueInput.focus()"
                            tabindex="0"
                        ></p-autoComplete>
                    </div>

                    <!-- Target Value -->
                    <div class="flex flex-col">
                        <label class="mb-1 font-medium" for="targetValue">Target Value</label>
                        <input
                            id="targetValue"
                            pInputText
                            [(ngModel)]="taskProgress.targetValue"
                            name="targetValue"
                            type="number"
                            class="p-inputtext p-component w-[130px]"
                            placeholder="Enter target value"
                            #targetValueInput
                            (keydown.enter)="commentsInput.focus()"
                        />
                    </div>

                    <!-- Comments -->
                    <div class="flex flex-col">
                        <label class="mb-1 font-medium" for="comments">Comments</label>
                        <input id="comments" pInputText [(ngModel)]="taskProgress.comments" name="comments" class="p-inputtext p-component w-[130px]" placeholder="Enter comments" #commentsInput (keydown.enter)="startDateInput.focus()" />
                    </div>

                    <!-- Start Date -->
                    <div class="flex flex-col">
                        <label class="mb-1 font-medium" for="startDate">Start Date</label>
                        <input id="startDate" pInputText [(ngModel)]="taskProgress.startDate" name="startDate" type="date" class="p-inputtext p-component w-[130px]" #startDateInput (keydown.enter)="endDateInput.focus()" />
                    </div>

                    <!-- End Date -->
                    <div class="flex flex-col">
                        <label class="mb-1 font-medium" for="endDate">End Date</label>
                        <input id="endDate" pInputText [(ngModel)]="taskProgress.endDate" name="endDate" type="date" class="p-inputtext p-component w-[130px]" #endDateInput (keydown.enter)="assignTaskButton?.focus()" />
                    </div>

                    <!-- Save Button -->
                    <div class="flex flex-col mt-4">
                        <button #assignTaskButton pButton label="Assign Task" icon="pi pi-check" (click)="saveTaskProgress()" type="button"></button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <p-toast />

    <div class="user-assignments-section w-full mb-8 rounded-xl border shadow font-sans">
        <button
            type="button"
            class="flex items-center gap-2 text-xll font-bold text-primary w-full text-left px-6 py-4 border-b focus:outline-none"
            (click)="toggleUserAssignmentsPanel()"
            [attr.aria-expanded]="userAssignmentsPanelOpen"
            aria-controls="userAssignmentsPanelSection"
        >
            <i class="pi" [ngClass]="userAssignmentsPanelOpen ? 'pi-minus-circle' : 'pi-plus-circle'"></i>
            User Assignments
        </button>
        <div *ngIf="userAssignmentsPanelOpen" id="userAssignmentsPanelSection" class="px-6 py-6">
            <!-- User Assignments Content -->
            <div class="user-table-section rounded-lg border shadow-sm p-6 overflow-x-auto">
                <!--   <h2 class="text-lg font-bold text-primary mb-4 border-b pb-2 flex items-center gap-2">
        <i class="pi pi-users"></i> User Assignments
      </h2> -->
                <!-- <p-button label="{{ isEditingTargets ? 'Done' : 'Edit' }}" icon="pi pi-pencil" (onClick)="isEditingTargets = !isEditingTargets" outlined></p-button> -->
                <!-- <div class="user-table-section rounded-lg border shadow-sm p-6"> -->
                <!-- <div style="overflow-x: auto; width: 100%"> -->
                    <p-table
                        #dt1
                        [value]="taskProgressList"
                        [paginator]="true"
                        [rows]="20"
                        [rowsPerPageOptions]="[20, 40, 60, 100]"
                        [showGridlines]="true"
                        [rowHover]="true"
                        [globalFilterFields]="['userName', 'targetValue', 'startDate', 'endDate']"
                        filterDisplay="menu"
                        [style]="{ minWidth: '1000px', width: '100%' }"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
                        [showCurrentPageReport]="true"
                        class="border rounded-xl"
                             appendTo="'body'"
                    >
                        <ng-template #caption>
                            <div class="flex justify-between items-center flex-wrap gap-4 w-full">
                                <div class="flex items-center gap-2">
                                    <!-- <button pButton label="Clear" icon="pi pi-filter-slash" class="p-button-outlined" (click)="clear(dt1)"></button> -->
                                    <p-button label="{{ isEditingTargets ? 'Done' : 'Edit' }}" icon="pi pi-pencil" (onClick)="isEditingTargets = !isEditingTargets" outlined *ngIf="!isReadOnly"></p-button>
                                </div>
                                <div class="flex items-center gap-2">
                                    <span class="p-input-icon-left">
                                        <p-iconfield>
                                            <p-inputicon styleClass="pi pi-search" />
                                            <input pInputText type="text" (input)="onGlobalFilter(dt1, $event)" placeholder="Search..." />
                                        </p-iconfield>
                                    </span>
                                </div>
                            </div>
                        </ng-template>

                        <ng-template pTemplate="header">
                            <tr class="sticky top-0 z-10">
                                <th style="width: 100px">
                                    <span class="flex items-center gap-2">
                                        Username
                                        <p-columnFilter type="text" field="userName" display="menu" placeholder="Filter" />
                                    </span>
                                </th>
                                <th style="width: 100px">
                                    <span class="flex items-center gap-2">
                                        Target
                                        <p-columnFilter type="numeric" field="targetValue" display="menu" placeholder="Filter" />
                                    </span>
                                </th>
                                <th style="width: 100px">
                                    <span class="flex items-center gap-2">
                                        Start Date
                                        <p-columnFilter type="date" field="startDate" display="menu" placeholder="yyyy-MM-dd" dateFormat="yyyy-mm-dd" />
                                    </span>
                                </th>
                                <th style="width: 100px">
                                    <span class="flex items-center gap-2">
                                        End Date
                                        <p-columnFilter type="date" field="endDate" display="menu" placeholder="Filter" dateFormat="yyyy-mm-dd" />
                                    </span>
                                </th>
                                <th style="width: 100px">
                                    <span class="flex items-center gap-2">
                                        Status
                                        <p-columnFilter type="text" field="flag" display="menu" placeholder="Filter" />
                                    </span>
                                </th>

                                <!-- Add this to your table header -->
                                <!-- <th style="width: 80px">Actions</th> -->
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                            <tr>
                                <td style="width: 100px">{{ row.userName }}</td>
                                <td style="width: 100px">
                                    <ng-container *ngIf="isEditingTargets; else staticTarget">
                                        <input type="number" [(ngModel)]="row.targetValue" (change)="markRowAsUpdated(row)" class="p-inputtext p-component w-full" />
                                    </ng-container>
                                    <ng-template #staticTarget>{{ row.targetValue }}</ng-template>
                                </td>
                                <td style="width: 100px">
                                    <ng-container *ngIf="isEditingTargets; else staticStartDate">
                                        <input
                                            type="date"
                                            [(ngModel)]="row.startDate"
                                            [ngModel]="row.startDate ? (row.startDate | date: 'yyyy-MM-dd') : ''"
                                            (ngModelChange)="row.startDate = $event; markRowAsUpdated(row)"
                                            (blur)="onStartDateBlur(row)"
                                            class="p-inputtext p-component w-full"
                                        />
                                    </ng-container>
                                    <ng-template #staticStartDate>{{ row.startDate | date: 'yyyy-MM-dd' }}</ng-template>
                                </td>
                                <td style="width: 100px">
                                    <ng-container *ngIf="isEditingTargets; else staticEndDate">
                                        <input
                                            type="date"
                                            [(ngModel)]="row.endDate"
                                            [ngModel]="row.endDate ? (row.endDate | date: 'yyyy-MM-dd') : ''"
                                            (ngModelChange)="row.endDate = $event; markRowAsUpdated(row)"
                                            (blur)="onEndDateBlur(row)"
                                            class="p-inputtext p-component w-full"
                                        />
                                    </ng-container>
                                    <ng-template #staticEndDate>{{ row.endDate | date: 'yyyy-MM-dd' }}</ng-template>
                                </td>
                                <td>{{ row.flag }}</td>
                                <!-- Add this to your table body row (inside <tr> ... </tr>) -->
                                <!-- <td>
    <button
        pButton
        icon="pi pi-trash"
        class="p-button-danger p-button-rounded p-button-outlined"
        (click)="deleteTaskProgress(row)"
        type="button"
        title="Delete"
    ></button>
</td> -->
                            </tr>
                        </ng-template>
                    </p-table>
                <!-- </div> -->
                <!-- </div> -->
            </div>
        </div>
    </div>
</div>
